export const LOCALSTORAGE_TOKEN_KEY = 'auth_token';
export const LOCALSTORAGE_DISCOUNT_CODE = 'discountcode';
export const INFORMATION_MODAL_RECORDED_TIME =
  'information_modal_recorded_time';
export const LOCALSTORAGE_COOKIE_CONSENT = 'lf_cookie_consent';
export const LOCALSTORAGE_FIRST_ORDER_FORM_COLLECTIONS =
  'lf_first_order_form_collections';
export const LOCALSTORAGE_TAGS = 'tags';
export const LOCALSTORAGE_DELIVERY_BAR_PERSISTED_STATE =
  'delivery-bar-persisted-state';
export const LOCALSTORAGE_MONTHLY_TO_YEARLY_MODAL =
  'monthly_to_yearly_modal_displayed';
export const LOCALSTORAGE_HOUSEHOLD_SIZE = 'temp_household_size';
export const LOCALSTORAGE_REGISTER_FLOW_MACHINE =
  'generic-funnel-persisted-state';
